const initialState = {
  banners: [],
  banner: null,
  total: 0,
  loading: false,
  error: null,
};

export const homeBannerReducer = (state = initialState, action) => {
  switch (action.type) {

    // Add Banner
    case "HOME_BANNER_ADD_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "HOME_BANNER_ADD_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };

    case "HOME_BANNER_ADD_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Update Banner
    case "HOME_BANNER_UPDATE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "HOME_BANNER_UPDATE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };

    case "HOME_BANNER_UPDATE_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Banner List
    case "HOME_BANNER_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "HOME_BANNER_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        banners: action.payload.data || [],
        total: action.payload.total || 0,
        error: null,
      };

    case "HOME_BANNER_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "CHANGE_HOME_BANNER_STATUS_REQUEST":
      return { ...state, loading: true };

    case "CHANGE_HOME_BANNER_STATUS_SUCCESS":
      return { ...state, loading: false };

    case "CHANGE_HOME_BANNER_STATUS_FAILED":
      return { ...state, loading: false, error: action.payload };


    // Banner View
    case "HOME_BANNER_VIEW_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "HOME_BANNER_VIEW_SUCCESS":
      return {
        ...state,
        loading: false,
        banner: action.payload.data || null,
        error: null,
      };

    case "HOME_BANNER_VIEW_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        banner: null,
      };

    case "CLEAR_BANNER_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};